(ns ui.view.card.activities.model)

(def loading-activities-path [:loading-activities?])

(defn loading-activities-full-path
  [card-state-path]
  (vec (concat card-state-path loading-activities-path)))

(def loading-emails-path [:loading-emails?])

(defn loading-emails-full-path
  [card-state-path]
  (vec (concat card-state-path loading-emails-path)))

(def activities-loaded-path [:activities-loaded?])

(defn activities-loaded-full-path
  [card-state-path]
  (into card-state-path activities-loaded-path))

(def emails-loaded-path [:emails-loaded?])

(defn emails-loaded-full-path
  [card-state-path]
  (into card-state-path emails-loaded-path))

(def selected-activity-tab-path [:selected-activity-tab])

(defn selected-activity-tab-full-path
  [card-state-path]
  (into card-state-path selected-activity-tab-path))

(def activity-tag-filters-path [:activity-tag-filters])

(defn activity-tag-filters-full-path
  [card-state-path]
  (into card-state-path activity-tag-filters-path))

(def collapse-activity-state-path [:collapse-activity])

(defn collapse-activity-state-full-path
  [card-state-path]
  (into card-state-path collapse-activity-state-path))

(defn collapse-activity-full-path
  [card-state-path activity-id]
  (conj (collapse-activity-state-full-path card-state-path) activity-id))

(def collapse-all-activities-path [:collapse-all-activities?])

(defn collapse-all-activities-full-path
  [card-state-path]
  (into card-state-path collapse-all-activities-path))
